export default __webpack_public_path__ + "static/media/pexels-alice-castro-1820041.f356c248.jpg";